import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { searchAdminIssuesUsers, type IssueUserOption } from '../api/adminIssuesApi';

// Backend requires at least 2 characters (adminIssuesUsersQuerySchema).
const MIN_QUERY_LENGTH = 2;

export const useAdminIssuesUsers = (serviceDeskId: number, query: string) =>
  useQuery<IssueUserOption[]>({
    queryKey: ['adminIssuesUsers', serviceDeskId, query],
    queryFn: () => searchAdminIssuesUsers(serviceDeskId, query),
    enabled: !!serviceDeskId && query.trim().length >= MIN_QUERY_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
